import axiosInstance from "@/api/axiosInstance";

export interface CostCenterDTO {
  id: number;
  name: string;
}

export class CostCenterService {
  private readonly basePath: string;

  constructor(basePath = "/cost-centers") {
    this.basePath = basePath;
  }

  public async getAll(): Promise<CostCenterDTO[]> {
    const url = `/api/v1${this.basePath}`;
    const response = await axiosInstance.get(url);
    return response.data;
  }

  public async adminGetAll(userId: number): Promise<CostCenterDTO[]> {
    const url = `/api/v1/admin/users/${userId}/cost-centers`;
    const response = await axiosInstance.get(url);
    return response.data;
  }

  public async adminGetAllForCompany(
    companyId: number
  ): Promise<CostCenterDTO[]> {
    const url = `/api/v1/admin/companies/${companyId}/cost-centers`;
    const response = await axiosInstance.get(url);
    return response.data;
  }

  public async createCostCenter(name: string): Promise<CostCenterDTO> {
    const response = await axiosInstance.post(`/api/v1${this.basePath}`, {
      name: name,
    });
    return response.data;
  }

  public async getCompanyCostCenters(): Promise<CostCenterDTO[]> {
    const response = await axiosInstance.get("/api/v1/company/cost-centers");
    return response.data;
  }

  public async getUserCostCenters(userId: number): Promise<CostCenterDTO[]> {
    const response = await axiosInstance.get(
      `/api/v1/company/users/${userId}/cost-centers`
    );
    return response.data;
  }

  public async updateUserCostCenters(
    userId: number,
    costCenterIds: number[]
  ): Promise<CostCenterDTO[]> {
    const response = await axiosInstance.put(
      `/api/v1/company/users/${userId}/cost-centers`,
      {
        costCenterIds,
      }
    );
    return response.data;
  }
}
